import React, {
  useCallback,
  useRef,
  useContext,
  useState,
  useEffect
} from "react";
import { InputCustomChangeEventHandler } from "../../types";
//import debug from "../../utils/debug";
import { clearDQRForm, convertPlaceToFormModel } from "../../utils/dqePlaces";
import { DqeAddress, getPlaces } from "../../utils/dqePlaces";
import InputText from "../InputText";
import { AnalyticsSessionContext } from "../../containers/CustomerPage";
import "./InputTextAutocompleteDqe.css";
import debug from "../../utils/debug";

export interface InputTextAutoCompleteDqeProps {
  id: string;
  name: string;
  value: any;
  onChange: InputCustomChangeEventHandler;
  country?: string;
  className: string;
}

export default function InputTextAutocompleteDqe({
  onChange,
  country,
  ...props
}: InputTextAutoCompleteDqeProps) {
  const analytics = useContext(AnalyticsSessionContext);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [suggestions, setSuggestions] = useState<DqeAddress[]>([]);
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
  const handleFocus = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowSuggestions(true);
  };

  const handleBlur = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setTimeout(() => {
      setShowSuggestions(false);
    }, 500);
  };

  const handleTextEntered = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    debug("[dqe] handleTextEntered:", value);
    if (onChange) {
      onChange(value || null, "streetAddress2");
    }
    if (country) {
      setSuggestions(
        value && value.length > 2 ? await getPlaces(country, value) : []
      );
    }
  };

  const handlePlaceSelect = useCallback(
    (place: DqeAddress) => {
      if (place) {
        const formModel = convertPlaceToFormModel(place);
        //debug("[dqe] place selected:", formModel);
        // The addressCountry   aren't supposed to be included
        // the the data which is merged, hence why they are individually
        // destructured and not subsequently used.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { addressCountry, ...data } = formModel;
        analytics.current.form.isAddressAutoCompleted = true;
        document.dispatchEvent(
          new CustomEvent("form.updateState", {
            detail: data
          })
        );

        // In order to force the form update in case the whole postal code is entered
        onChange("", props.id);
      }
    },
    [onChange]
  );

  return (
    <div>
      <InputText
        {...props}
        onChange={handleTextEntered}
        onFocus={handleFocus}
        onBlur={handleBlur}
        ref={inputRef}
        placeholder=""
        type="text"
      />
      <div className="suggestions-wrap">
        <div className="suggestions">
          {showSuggestions &&
            suggestions.map((suggestion, index) => (
              <div
                className="suggestion"
                key={index}
                onClick={() => handlePlaceSelect(suggestion)}
              >
                {suggestion.label}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
